export default "__VITE_ASSET__QFHPazgX__"